import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RootclassService {

  subject: BehaviorSubject<string> = new BehaviorSubject<string>('default')

  getSubject() {
    return this.subject
  }
}
